<div class="container-fluid">
  <div class="row">
    <app-chart-widget
      [widgetPanelCharts]="widgetPanelChart"
      [widgetPanel]="{ style: {} }"
      [title]="'Resolving Vendors'"
    ></app-chart-widget>
  </div>
</div>
